export default () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9 32.9755C11.9 32.0366 12.6611 31.2755 13.6 31.2755H19.5106H21.3286C24.0261 31.2755 26.5524 29.9537 28.0904 27.7376L29.6177 25.5369C30.2589 24.613 30.7135 23.5728 30.956 22.4747L31.4752 20.1235C31.878 18.299 33.4952 17 35.3637 17C37.2512 17 38.8795 18.3252 39.2628 20.1734L39.515 21.3892C39.8802 23.1498 39.5349 24.9834 38.5543 26.4906L35.4411 31.2755H42.5669C47.4156 31.2755 50.7272 36.1778 48.9171 40.6759L44.2789 52.2016C43.0579 55.2359 39.9463 57.0671 36.7009 56.6614L19.5106 54.5126H13.6C12.6611 54.5126 11.9 53.7515 11.9 52.8126V32.9755Z"
      fill="#8FB4FF"
    />
    <path
      d="M13.6 34C13.6 33.5306 13.9806 33.15 14.45 33.15H19.55V52.7H14.45C13.9806 52.7 13.6 52.3195 13.6 51.85V34Z"
      fill="white"
    />
    <path
      d="M53.1677 4.71771C54.0372 8.2627 56.805 11.0306 60.35 11.9C56.805 12.7694 54.0372 15.5373 53.1677 19.0823C52.2983 15.5373 49.5304 12.7694 45.9854 11.9C49.5304 11.0306 52.2983 8.2627 53.1677 4.71771Z"
      fill="#CDDBF6"
    />
    <path
      d="M61.6677 20.0177C62.262 22.4406 64.1537 24.3323 66.5766 24.9266C64.1537 25.5208 62.262 27.4125 61.6677 29.8354C61.0735 27.4125 59.1818 25.5208 56.7589 24.9266C59.1818 24.3323 61.0735 22.4406 61.6677 20.0177Z"
      fill="#CDDBF6"
    />
  </svg>
)
